const _version = "3.2.0"
function version() {
    return _version
}
export default version
